module.exports = __webpack_public_path__ + "static/media/P24.d91a9c62.png";